import React from 'react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
import { BookOpen, ShieldCheck, Heart, Zap } from 'lucide-react';
export function MethodSection() {
  const benefits = [{
    icon: Zap,
    text: 'Rediseñar rutinas digitales'
  }, {
    icon: ShieldCheck,
    text: 'Establecer límites claros sin confrontaciones'
  }, {
    icon: BookOpen,
    text: 'Crear hábitos sostenibles'
  }, {
    icon: Heart,
    text: 'Mejorar el ambiente en casa'
  }];
  return <section className="py-8 bg-[#1a1a2e] text-white relative overflow-hidden" data-id="element-90">
      {/* Background decoration */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#F97316]/10 blur-[120px] rounded-full pointer-events-none" data-id="element-91" />
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#0ABFBC]/10 blur-[120px] rounded-full pointer-events-none" data-id="element-92" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-93">
        <div className="max-w-4xl mx-auto text-center" data-id="element-94">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-95">
            <span className="text-[#0ABFBC] font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-96">
              La Solución
            </span>
            <h2 className="text-4xl md:text-5xl font-extrabold mb-3 font-montserrat" data-id="element-97">
              Presentamos:{' '}
              <span className="text-white" data-id="element-98">El Interruptor Digital</span>
            </h2>
            <p className="text-xl text-gray-300 mb-6 max-w-2xl mx-auto" data-id="element-99">
              Una guía práctica de 7 días diseñada para ayudarte a recuperar el
              control sin perder la conexión con tus hijos.
            </p>
          </motion.div>

          <div className="grid sm:grid-cols-2 gap-3 mb-6" data-id="element-100">
            {benefits.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white/5 backdrop-blur-sm border border-white/10 p-4 rounded-xl flex items-center gap-4 text-left hover:bg-white/10 transition-colors" data-id="element-101">
                <div className="w-12 h-12 rounded-full bg-[#F97316]/20 flex items-center justify-center flex-shrink-0" data-id="element-102">
                  <item.icon className="w-6 h-6 text-[#F97316]" data-id="element-103" />
                </div>
                <span className="font-medium text-lg" data-id="element-104">{item.text}</span>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} data-id="element-105">
            <p className="text-gray-400 mb-8 italic" data-id="element-106">
              Sin tecnicismos. Sin teorías complicadas. Solo pasos concretos.
            </p>
            <Button variant="primary" size="lg" onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-107">
              Quiero mi guía ahora
            </Button>
          </motion.div>
        </div>
      </div>
    </section>;
}